<ng-container *ngIf="isLoading; else pageContent">
  <div class="app-spinner">
    <mat-spinner></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <div class="course-header">
    <div class="top-row">
      <img src="assets/images/arrow_left_alt.svg" (click)="goBack()" />
      <div class="justify-content-start">
        <h2 class="quiz-title">
          {{ _quizName || (_quizService.quizName | async) }}
        </h2>
      </div>
      <div
        class="text-end d-flex align-items-center gap-1 ms-auto"
        *ngIf="quizStatus === CourseStatusEnum.Draft"
      >
        <button type="button" class="add-btn" (click)="openEditQuizDialogBox()">
          <i class="bi bi-pencil"></i>
          Edit
        </button>
        <div class="draft-status">
          <i class="bi bi-check2-circle"></i> Drafted
        </div>
      </div>
    </div>

    <div class="cards-wrapper">
      <div class="info-card">
        <div class="icon">
          <i class="bi bi-clock"></i>
        </div>

        <div class="content">
          <div class="title">DURATION</div>
          <div class="subtitle">
            {{ formatTime(fullQuizData.time_limit || 0) }}
          </div>
        </div>
      </div>

      <div class="info-card">
        <div class="icon">
          <i class="bi bi-shield-check"></i>
        </div>

        <div class="content">
          <div class="title">ATTEMPTS</div>
          <div class="subtitle">{{ quizAttempts }}</div>
        </div>
      </div>

      <div class="info-card">
        <div class="icon">
          <i class="bi bi-award"></i>
        </div>

        <div class="content">
          <div class="title">PASSING SCORE</div>
          <div class="subtitle">{{ quizScore }}</div>
        </div>
      </div>

      <div class="info-card">
        <div class="icon">
          <i class="bi bi-list-ol"></i>
        </div>

        <div class="content">
          <div class="title">QUESTIONS / USER</div>
          <div class="subtitle">{{ quizQuestion }}</div>
        </div>
      </div>
    </div>

    <div class="d-flex badges-row">
      <ng-container *ngIf="fullQuizData?.shuffle_questions">
        <span class="badge shuffle">
          <i class="bi bi-shuffle me-1"></i>
          Shuffle Question</span
        >
      </ng-container>

      <ng-container *ngIf="fullQuizData?.shuffle_options">
        <span class="badge shuffle">
          <i class="bi bi-shuffle me-1"></i>
          Shuffle Option</span
        >
      </ng-container>

      <!-- <span class="badge proctor">
      <i class="bi bi-shield-check me-1"></i>  
      Non-Proctored</span> not using now -->
    </div>

    <div class="divider"></div>

    <div class="course" *ngIf="fullQuizData?.course_title">
      <span>
        <i class="bi bi-people me-1"></i>
        Publish to course : {{ fullQuizData.course_title }}
      </span>
    </div>
  </div>

  <div class="quiz-section mb-5">
    <div class="d-flex justify-content-between align-item-center mb-1">
      <h3 *ngIf="_quizData">
        Quiz Questions ({{ _quizData.length || 0 }} Questions)
      </h3>
      <ng-container *hasPermission="PermissionForStudents.QUIZ_CREATE">
        <button
          class="btn-add mt-0"
          (click)="goToQuizPage()"
          *ngIf="quizStatus === CourseStatusEnum.Draft"
        >
          Add Questions
        </button>
      </ng-container>
    </div>
    <div
      class="questions-list"
      cdkDropList
      cdkDropListSortingDisabled="false"
      (cdkDropListDropped)="drop($event)"
    >
      <div
        class="question-card"
        *ngFor="
          let quizQuestion of _quizData;
          let i = index;
          trackBy: trackByQuestion
        "
        [id]="'question-' + i"
        cdkDrag
        cdkDragLockAxis="y"
        [cdkDragStartDelay]="100"
        [cdkDragDisabled]="quizStatus === CourseStatusEnum.Published"
      >
        <div class="question-header">
          <img
            src="assets/images/drag.png"
            class="topic-icon drag-handle"
            alt="drag-icon"
            cdkDragHandle
          />
          <span class="question-number">Q{{ i + 1 }}</span>
          <span class="question-type">{{ quizQuestion.question_type }}</span>
          <span class="question-score">{{ quizQuestion.marks }} pt</span>
        </div>
        <span *ngIf="quizQuestion.needs_review" class="review-badge">
          &#9888; Needs Review
        </span>
        <div class="question-text">
          <app-question-blocks
            [blocks]="quizQuestion.question_blocks || null"
            [content]="quizQuestion.question_text">
          </app-question-blocks>
          <div *ngIf="quizQuestion.diagram_url || (quizQuestion.has_diagram && quizQuestion.diagram_url)" class="mt-2 text-start">
            <img [src]="quizQuestion.diagram_url" alt="Question Image" class="img-fluid rounded" style="max-height: 200px;">
          </div>
        </div>

        <ul
          class="options"
          *ngIf="quizQuestion.question_type === QuizQuestionType.TRUE_FALSE"
        >
          <li
            [ngClass]="{
              correct:
                ('' + quizQuestion.correct_answer).toLowerCase().trim() ===
                'true',
            }"
          >
            <div class="option-left">
            <span class="option-prefix">A.</span>
            <app-math-latex [content]="'True'"></app-math-latex>
            </div>
            <i class="bi bi-check-circle-fill check-icon" *ngIf="('' + quizQuestion.correct_answer).toLowerCase().trim() === 'true'"></i>
          </li>
          <li
            [ngClass]="{
              correct:
                ('' + quizQuestion.correct_answer).toLowerCase().trim() ===
                'false',
            }"
          >
            <div class="option-left">
            <span class="option-prefix">B.</span>
            <app-math-latex [content]="'False'"></app-math-latex>
            </div>
            <i class="bi bi-check-circle-fill check-icon" *ngIf="('' + quizQuestion.correct_answer).toLowerCase().trim() === 'false'"></i>
          </li>
        </ul>

        <ul
          class="options"
          *ngIf="quizQuestion.question_type === QuizQuestionType.OPEN_ENDED"
        >
          <p class="key-answer">Key Answer:</p>
          <div class="answer-box">
            <app-math-latex
              [content]="quizQuestion.correct_answer || quizQuestion.key_answer"
            ></app-math-latex>
          </div>
        </ul>

        <ul
          class="options"
          *ngIf="quizQuestion.question_type === QuizQuestionType.MCQ"
        >
          <li
            *ngFor="let option of quizQuestion.options; let i = index"
            [ngClass]="{
              correct:
               i === getCorrectOptionIndex(quizQuestion.options ?? [], quizQuestion.correct_answer),
            }"
          >
            <div class="option-left">
            <span class="option-prefix"> {{ getOptionLabel(i) }} .</span>
            <app-question-blocks
              [blocks]="option.blocks || null"
              [content]="option.text || ''"
                [stripOptionPrefix]="true"
              [diagrams]="[]">
            </app-question-blocks>
            <img
              *ngIf="option.image_url && (!option.blocks || option.blocks.length === 0)"
              [src]="option.image_url"
              [alt]="option.text || 'option image'"
              class="option-diagram" />
            </div>
            <i class="bi bi-check-circle-fill check-icon" *ngIf=" i === getCorrectOptionIndex(quizQuestion.options ?? [], quizQuestion.correct_answer)"></i>
          </li>
        </ul>

        <div
          class="d-flex badges-row mt-2"
          *ngIf="quizQuestion.question_type === QuizQuestionType.MCQ"
        >
          <ng-container
            *ngIf="
              quizQuestion.difficulty_level &&
              quizQuestion.topic &&
              quizQuestion.subject
            "
          >
            <span class="badge difficulty">
              {{ quizQuestion.difficulty_level }}
            </span>

            <span class="badge course">
              {{ quizQuestion.subject }}
            </span>

            <span class="badge topic">
              {{ quizQuestion.topic }}
            </span>
            <span class="badge"> MCQ </span>
          </ng-container>
        </div>
        <div class="actions">
          <ng-container *hasPermission="PermissionForStudents.QUIZ_UPDATE">
            <img
              src="assets/images/edit.svg"
              alt="Edit"
              *ngIf="quizStatus !== CourseStatusEnum.Published"
              class="edit-icon"
              (click)="editQuestion(quizQuestion)"
            />
          </ng-container>

          <ng-container *hasPermission="PermissionForStudents.QUIZ_DELETE">
            <img
              src="assets/images/delete.svg"
              alt="Delete"
              class="delete-icon"
              *ngIf="quizStatus !== CourseStatusEnum.Published"
              (click)="
                openDeleteDialogBox(quizId, quizQuestion.question_id || '', i)
              "
            />
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div
    *ngIf="currentPopup === QuizQuestionType.MCQ"
    class="popup"
    (click)="closePopup($event)"
  >
    <div (click)="$event.stopPropagation()">
      <h3>Edit Question</h3>
      <i class="bi bi-x close-icon" (click)="closePopup()"></i>

      <form [formGroup]="quizForm">
        <label>Question Text*</label>
        <textarea
          formControlName="question_text"
          placeholder="Add your question here..."
          class="question-textarea"
        ></textarea>
        <small
          *ngIf="
            quizForm.get('question_text')?.invalid &&
            (quizForm.get('question_text')?.touched ||
              quizForm.get('question_text')?.dirty)
          "
          class="text-danger smaller-text"
        >
          Question is required.</small
        >

        <div class="mt-3 mb-3" *ngIf="isEditingManualQuestion">
          <input type="file" #editImageUpload accept=".jpg,.jpeg,.png" style="display: none" (change)="onEditImageUpload($event)">
          <button type="button" class="upload-btn" (click)="editImageUpload.click()">
            <i class="bi bi-image"></i> Upload Image (optional)
          </button>
          <div *ngIf="uploadedImageUrl" class="uploaded-image-preview mt-2 d-flex align-items-center">
            <img [src]="uploadedImageUrl" alt="Question Image" width="100" height="auto" class="rounded">
            <i class="bi bi-trash ms-2 text-danger cursor-pointer fs-5" (click)="removeImage()"></i>
          </div>
        </div>

        <label>Answer Options</label>
        <div formArrayName="options" class="options-list">
          <div
            class="option-item"
            *ngFor="let opt of options.controls; let i = index"
            [formGroupName]="i"
          >
            <input
              type="radio"
              [value]="i"
              [formControl]="correctAnswerFormControl"
            />
            <input
              type="text"
              formControlName="text"
              placeholder="Option {{ i + 1 }}"
            />
            <input formControlName="order" type="hidden" />
            <button type="button" class="remove-option-btn" (click)="removeOption(i)"
              *ngIf="options.length > MIN_OPTIONS" title="Remove option">
              <i class="bi bi-x-circle"></i>
            </button>
          </div>
        </div>
        <button type="button" class="add-option-btn" (click)="addOption()"
          *ngIf="options.length < MAX_OPTIONS">
          <i class="bi bi-plus-circle"></i> Add Option
        </button>

        <small
          *ngIf="
            quizForm.get('options')?.hasError('noOptions') &&
            (quizForm.get('options')?.touched || quizForm.get('options')?.dirty)
          "
          class="text-danger smaller-text"
        >
          At least one option is required.</small
        >

        <small
          *ngIf="
            quizForm.get('options')?.hasError('emptyOption') &&
            (quizForm.get('options')?.touched || quizForm.get('options')?.dirty)
          "
          class="text-danger smaller-text"
        >
          Option text cannot be empty.</small
        >

        <small
          *ngIf="
            quizForm.get('options')?.hasError('duplicateOptions') &&
            (quizForm.get('options')?.touched || quizForm.get('options')?.dirty)
          "
          class="text-danger smaller-text"
        >
          Duplicate options are not allowed. Please fix them before saving.
        </small>

        <label>Points</label>
        <input
          type="number"
          formControlName="marks"
          placeholder="e.g. 1"
          class="points-input"
        />

        <small
          *ngIf="
            quizForm.get('marks')?.hasError('required') &&
            (quizForm.get('marks')?.touched || quizForm.get('marks')?.dirty)
          "
          class="text-danger smaller-text"
        >
          Points are required.</small
        >

        <small
          *ngIf="
            quizForm.get('marks')?.hasError('min') &&
            (quizForm.get('marks')?.touched || quizForm.get('marks')?.dirty)
          "
          class="text-danger smaller-text"
        >
          Points must be at least 1.</small
        >

        <div class="action-buttons">
          <button class="cancel" type="button" (click)="closePopup()">
            Cancel
          </button>
          <button
            class="save"
            type="button"
            (click)="updateQuizQuestion()"
            [disabled]="isUpdateDisabled || isUpdating"
          >
            <span *ngIf="isUpdating" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Save Changes
          </button>
        </div>
      </form>
    </div>
  </div>

  <div
    *ngIf="currentPopup === QuizQuestionType.TRUE_FALSE"
    class="popup"
    (click)="closePopup($event)"
  >
    <div (click)="$event.stopPropagation()">
      <h3>Edit Question</h3>
      <i class="bi bi-x close-icon" (click)="closePopup()"></i>

      <form [formGroup]="quizForm">
        <label>Question Text*</label>
        <textarea
          formControlName="question_text"
          placeholder="Add your question here..."
          class="question-textarea"
        ></textarea>
        <small
          *ngIf="
            quizForm.get('question_text')?.invalid &&
            (quizForm.get('question_text')?.touched ||
              quizForm.get('question_text')?.dirty)
          "
          class="text-danger smaller-text"
        >
          Question is required.</small
        >

        <div class="mt-3 mb-3" *ngIf="isEditingManualQuestion">
          <input type="file" #editImageUploadTF accept=".jpg,.jpeg,.png" style="display: none" (change)="onEditImageUpload($event)">
          <button type="button" class="upload-btn" (click)="editImageUploadTF.click()">
            <i class="bi bi-image"></i> Upload Image (optional)
          </button>
          <div *ngIf="uploadedImageUrl" class="uploaded-image-preview mt-2 d-flex align-items-center">
            <img [src]="uploadedImageUrl" alt="Question Image" width="100" height="auto" class="rounded">
            <i class="bi bi-trash ms-2 text-danger cursor-pointer fs-5" (click)="removeImage()"></i>
          </div>
        </div>

        <!-- Image blocks: show existing diagrams and allow URL updates -->
        <ng-container *ngIf="questionImages.controls.length > 0" formArrayName="questionImages">
          <label>Question Diagrams</label>
          <div class="image-edit-block" *ngFor="let imgCtrl of questionImages.controls; let imgIdx = index">
            <img *ngIf="imgCtrl.value" [src]="imgCtrl.value" alt="Diagram {{imgIdx + 1}}" class="edit-preview-image" />
            <label class="image-url-label">Diagram {{imgIdx + 1}} — Update S3 URL (optional):</label>
            <input type="text" [formControlName]="imgIdx" placeholder="Paste new S3 URL here or leave to keep current" class="form-control image-url-input" />
          </div>
        </ng-container>

        <label>Answer Options</label>
        <div class="radio-group">
          <label>
            <input type="radio" formControlName="correct_answer" value="true" />
            True
          </label>
          <label>
            <input
              type="radio"
              formControlName="correct_answer"
              value="false"
            />
            False
          </label>
        </div>

        <label>Points</label>
        <input
          type="number"
          formControlName="marks"
          placeholder="e.g. 1"
          class="points-input"
        />

        <small
          *ngIf="
            quizForm.get('marks')?.hasError('required') &&
            (quizForm.get('marks')?.touched || quizForm.get('marks')?.dirty)
          "
          class="text-danger smaller-text"
        >
          Points are required.</small
        >

        <small
          *ngIf="
            quizForm.get('marks')?.hasError('min') &&
            (quizForm.get('marks')?.touched || quizForm.get('marks')?.dirty)
          "
          class="text-danger smaller-text"
        >
          Points must be at least 1.</small
        >

        <div class="action-buttons">
          <button class="cancel" type="button" (click)="closePopup()">
            Cancel
          </button>
          <button
            class="save"
            type="button"
            (click)="updateQuizQuestion()"
            [disabled]="
              (quizForm.invalid && quizForm.value.question_type === 'MCQ') ||
              (quizForm.value.question_type === 'TRUE_FALSE' &&
                !quizForm.value.correct_answer) ||
              (quizForm.value.question_type === 'OPEN_ENDED' &&
                !quizForm.value.key_answer) || isUpdating
            "
          >
            <span *ngIf="isUpdating" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Save Changes
          </button>
        </div>
      </form>
    </div>
  </div>

  <div
    *ngIf="currentPopup === QuizQuestionType.OPEN_ENDED"
    class="popup"
    (click)="closePopup($event)"
  >
    <div (click)="$event.stopPropagation()">
      <h3>Edit Question</h3>
      <i class="bi bi-x close-icon" (click)="closePopup()"></i>

      <form [formGroup]="quizForm">
        <label>Question Text*</label>
        <textarea
          formControlName="question_text"
          placeholder="Add your question here..."
          class="question-textarea"
        ></textarea>
        <small
          *ngIf="
            quizForm.get('question_text')?.invalid &&
            (quizForm.get('question_text')?.touched ||
              quizForm.get('question_text')?.dirty)
          "
          class="text-danger smaller-text"
        >
          Question is required.</small
        >

        <div class="mt-3 mb-3" *ngIf="isEditingManualQuestion">
          <input type="file" #editImageUploadOE accept=".jpg,.jpeg,.png" style="display: none" (change)="onEditImageUpload($event)">
          <button type="button" class="upload-btn" (click)="editImageUploadOE.click()">
            <i class="bi bi-image"></i> Upload Image (optional)
          </button>
          <div *ngIf="uploadedImageUrl" class="uploaded-image-preview mt-2 d-flex align-items-center">
            <img [src]="uploadedImageUrl" alt="Question Image" width="100" height="auto" class="rounded">
            <i class="bi bi-trash ms-2 text-danger cursor-pointer fs-5" (click)="removeImage()"></i>
          </div>
        </div>

        <!-- Image blocks: show existing diagrams and allow URL updates -->
        <ng-container *ngIf="questionImages.controls.length > 0" formArrayName="questionImages">
          <label>Question Diagrams</label>
          <div class="image-edit-block" *ngFor="let imgCtrl of questionImages.controls; let imgIdx = index">
            <img *ngIf="imgCtrl.value" [src]="imgCtrl.value" alt="Diagram {{imgIdx + 1}}" class="edit-preview-image" />
            <label class="image-url-label">Diagram {{imgIdx + 1}} — Update S3 URL (optional):</label>
            <input type="text" [formControlName]="imgIdx" placeholder="Paste new S3 URL here or leave to keep current" class="form-control image-url-input" />
          </div>
        </ng-container>

        <label>Key Answer</label>
        <textarea
          formControlName="key_answer"
          placeholder="Add a reference answer to help with evaluating student responses accurately."
        ></textarea>
        <small
          *ngIf="
            quizForm.get('key_answer')?.invalid &&
            (quizForm.get('key_answer')?.touched ||
              quizForm.get('key_answer')?.dirty)
          "
          class="text-danger smaller-text"
        >
          Answer is required.</small
        >

        <label>Points</label>
        <input
          type="number"
          formControlName="marks"
          placeholder="e.g. 1"
          class="points-input"
        />

        <small
          *ngIf="
            quizForm.get('marks')?.hasError('required') &&
            (quizForm.get('marks')?.touched || quizForm.get('marks')?.dirty)
          "
          class="text-danger smaller-text"
        >
          Points are required.</small
        >

        <small
          *ngIf="
            quizForm.get('marks')?.hasError('min') &&
            (quizForm.get('marks')?.touched || quizForm.get('marks')?.dirty)
          "
          class="text-danger smaller-text"
        >
          Points must be at least 1.</small
        >

        <div class="action-buttons">
          <button class="cancel" (click)="closePopup()">Cancel</button>
          <button
            class="save"
            (click)="updateQuizQuestion()"
            [disabled]="
              quizForm.get('question_text')?.invalid ||
              quizForm.get('key_answer')?.invalid ||
              quizForm.get('marks')?.invalid || isUpdating
            "
          >
            <span *ngIf="isUpdating" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Save Changes
          </button>
        </div>
      </form>
    </div>
  </div>

  <div class="footer-bar" *ngIf="_quizData?.length">
    <div class="button-group">
      <ng-container *hasPermission="PermissionForStudents.QUIZ_UPDATE">
        <button
          class="btn outline"
          (click)="openUnpublishDialogBox()"
          [disabled]="isDraft"
          *ngIf="quizStatus === CourseStatusEnum.Published"
        >
          <i class="bi bi-save"></i>
          <ng-container *ngIf="!isDraft; else noDraft"
            >Unpublish Quiz</ng-container
          >
          <ng-template #noDraft>
            <span class="spinner-text">
              <mat-spinner [diameter]="20" class="spinner-white"></mat-spinner
              >UnPublishing...
            </span>
          </ng-template>
        </button>
      </ng-container>

      <ng-container *hasPermission="PermissionForStudents.QUIZ_DELETE">
        <button
          class="btn outline"
          *ngIf="!isNewQuiz && quizStatus === CourseStatusEnum.Draft"
          [disabled]="isDraft"
          (click)="openDeleteQuizDialogBox(fullQuizData.quiz_id)"
        >
          Remove from draft
        </button>
      </ng-container>

      <ng-container *hasPermission="PermissionForStudents.QUIZ_UPDATE">
        <button
          class="btn outline"
          (click)="changeQuizStatus(CourseStatusEnum.Draft)"
          *ngIf="isNewQuiz && quizStatus === CourseStatusEnum.Draft"
        >
          <ng-container *ngIf="!isDraft; else noDraft"
            >Save as Draft</ng-container
          >
          <ng-template #noDraft>
            <span class="spinner-text">
              <mat-spinner [diameter]="20"></mat-spinner>Saving...</span
            >
          </ng-template>
        </button>

        <button
          class="btn solid"
          (click)="changeQuizStatus(CourseStatusEnum.Published)"
          [disabled]="isPublishing"
          *ngIf="quizStatus === CourseStatusEnum.Draft"
        >
          <ng-container *ngIf="!isPublishing; else noPublishing"
            >Publish Quiz</ng-container
          >
          <ng-template #noPublishing>
            <span class="spinner-text">
              <mat-spinner [diameter]="20" class="spinner-white"></mat-spinner
              >Publishing...</span
            >
          </ng-template>
        </button>
      </ng-container>
    </div>
  </div>
</ng-template>
